module.exports = __webpack_public_path__ + "close.svg?c001b7";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icons/close.svg
// module id = 254
// module chunks = 0